import type { AuthErrorKeyMap } from '../../../types/auth';

export const updatePasswordAuthErrorConfig: AuthErrorKeyMap = {
    key: 'updatePassword',
    value: {
        422: {
            same_password: 'errors.frontend.updatePassword.samePassword',
            weak_password: 'errors.frontend.updatePassword.weakPassword',
            validation_failed: 'errors.frontend.updatePassword.validationFailed',
        },
        default: 'errors.frontend.passwordUpdateFailed',
    },
};
